module.exports = __webpack_public_path__ + "img/newinsta.55cd3b2c.svg";